/**
 * Zero-decimal currencies — Stripe treats these as whole units (no fractional cents).
 * For example, KES 140 is passed as unit_amount: 140 (not 14000).
 * Reference: https://docs.stripe.com/currencies#zero-decimal
 */
export const ZERO_DECIMAL_CURRENCIES = new Set([
  'bif', 'clp', 'djf', 'gnf', 'jpy', 'kmf', 'krw', 'mga',
  'pyg', 'rwf', 'ugx', 'vnd', 'vuv', 'xaf', 'xof', 'xpf',
  'kes', 'tzs',
]);

/**
 * Format a USD amount (in dollars, e.g. 9.99) to the correct Stripe unit_amount
 * for the target currency. For zero-decimal currencies the amount is rounded to
 * whole units; for standard currencies it is converted to cents.
 *
 * @param {number} amountInTargetCurrency - price in the target currency (e.g. 140 for KES)
 * @param {string} currency - ISO 4217 lowercase currency code
 * @returns {number} integer unit_amount for Stripe
 */
export function toStripeUnitAmount(amountInTargetCurrency, currency) {
  const code = (currency || 'usd').toLowerCase();
  if (ZERO_DECIMAL_CURRENCIES.has(code)) {
    return Math.round(amountInTargetCurrency);
  }
  return Math.round(amountInTargetCurrency * 100);
}
